module.exports = __webpack_public_path__ + "static/media/2.f2eb5dda.jpg";